/* XRED · product page. Variant radios drive price, availability, media, URL;
   pack and plan price recompute; the qty stepper; add to cart through
   XRED.addToCart; gallery thumbs; phone slides and dots; the sticky buy bar.
   Also the one delegated handler for every [data-add] quick add button on a
   page that loads this file. Re-inits on shopify:section:load. */
(function () {
  'use strict';
  var H = window.XRED || (window.XRED = { routes: {}, strings: {} });
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(c) { return H.formatMoney ? H.formatMoney(c) : '$' + (c / 100).toFixed(2); }

  /* ------------------------------------------------------- add to cart */
  function addToCart(fd) {
    if (H.addToCart) return Promise.resolve(H.addToCart(fd));
    // Fallback until xred-global.js provides it: same contract, same event.
    return fetch(H.routes.cartAdd || '/cart/add', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || H.strings.cartError || 'Error');
        document.dispatchEvent(new CustomEvent('xred:cart:added', { detail: res.body }));
        if (H.toast && !$('[data-cart-open]')) H.toast(H.strings.addedToCart || 'Added', { link: true });
        return res.body;
      });
  }
  function flash(btn) {
    if (!btn) return;
    btn.classList.add('btn--added');
    setTimeout(function () { btn.classList.remove('btn--added'); }, 1200);
  }
  if (!H.__quickAddBound) {
    H.__quickAddBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add]'); if (!btn || btn.disabled) return;
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', btn.getAttribute('data-add'));
      fd.append('quantity', '1');
      btn.disabled = true;
      addToCart(fd).then(function () { flash(btn); }).catch(function (err) { if (H.toast) H.toast(err.message || H.strings.cartError); })
        .then(function () { btn.disabled = false; });
    });
  }

  /* --------------------------------------------------------- section */
  function initSection(section) {
    if (!section || section.__xrProduct) return;
    section.__xrProduct = true;
    var product = null;
    try { product = JSON.parse($('[data-product-json]', section).textContent); } catch (e) { return; }

    var root = section.closest('.shopify-section') || section.parentElement || document;
    var picker = $('[data-variant-picker]', section);
    var form = $('[data-pdp-form]', section);
    var variantInput = $('[data-variant-id]', section);
    var addBtn = $('[data-add-to-cart]', section);
    var addLabel = $('[data-add-label]', section);
    var lineTotal = $('[data-line-total]', section);
    var priceNow = $('[data-price-now]', section);
    var priceWas = $('[data-price-was]', section);
    var qtyWrap = $('.buyrow .qty', section);
    var qtyInput = qtyWrap && $('.qty__input', qtyWrap);
    var planWrap = $('[data-plan]', section);
    var planSelect = $('[data-plan-select]', section);
    var every = planWrap && $('.plan__every', planWrap);
    var hero = $('[data-hero]', section);
    var thumbs = $$('.pdp__thumbs button', section);
    var slides = $('[data-slides]', section);
    var dots = $$('[data-dots] i', section);
    var buybar = $('[data-buybar]', root);
    var buybarPrice = buybar && $('[data-buybar-price]', buybar);
    var buybarBtn = buybar && $('[data-buybar-add]', buybar);
    var pickupEl = $('[data-pickup-availability]', section);
    var errEl = $('[data-form-error]', section);
    var variant = null;

    function selectedOptions() {
      if (!picker) return null;
      var opts = [];
      $$('input[data-option-index]:checked', picker).forEach(function (el) { opts[parseInt(el.dataset.optionIndex, 10)] = el.value; });
      return opts;
    }
    function findVariant(opts) {
      if (!opts) return product.variants.find(function (v) { return String(v.id) === String(variantInput && variantInput.value); }) || product.variants[0];
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
    }
    function markAvailability(opts) {
      if (!picker || !opts) return;
      $$('input[data-option-index]', picker).forEach(function (el) {
        var i = parseInt(el.dataset.optionIndex, 10);
        var test = opts.slice(); test[i] = el.value;
        var v = product.variants.find(function (x) { return x.options.every(function (o, j) { return o === test[j]; }); });
        var label = el.closest('label');
        if (label) label.classList.toggle('is-unavailable', !(v && v.available));
      });
    }
    function qty() { return Math.max(1, Math.min(12, parseInt(qtyInput && qtyInput.value, 10) || 1)); }
    function isSub() {
      if (!planWrap) return false;
      var r = $('input[value="sub"]', planWrap);
      return !!(r && r.checked);
    }
    function allocation(v) {
      if (!v || !isSub() || !planSelect || !v.selling_plan_allocations) return null;
      var id = planSelect.value;
      return v.selling_plan_allocations.find(function (a) { return String(a.selling_plan_id) === String(id); }) || null;
    }
    function priceOf(v) {
      var a = allocation(v);
      if (a) return { now: a.price, was: a.compare_at_price && a.compare_at_price > a.price ? a.compare_at_price : (v.price > a.price ? v.price : null) };
      return { now: v.price, was: v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null };
    }

    function render() {
      var v = variant;
      if (every) every.hidden = !isSub();
      if (planSelect) planSelect.disabled = !isSub();
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = H.strings.unavailable || 'Unavailable';
        if (buybarBtn) { buybarBtn.disabled = true; buybarBtn.firstElementChild.textContent = H.strings.unavailable || 'Unavailable'; }
        return;
      }
      var p = priceOf(v);
      var q = qty();
      if (priceNow) priceNow.textContent = money(p.now);
      if (priceWas) { priceWas.hidden = !p.was; priceWas.textContent = p.was ? money(p.was) : ''; }
      if (lineTotal) lineTotal.textContent = money(p.now * q);
      if (buybarPrice) buybarPrice.textContent = money(p.now * q) + (isSub() ? ' · ' + (H.strings.subscription || 'subscription') : '');
      var label = v.available ? (H.strings.addToCart || 'Add to cart') : (H.strings.soldOut || 'Sold out');
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = label;
      if (buybarBtn) { buybarBtn.disabled = !v.available; buybarBtn.firstElementChild.textContent = label; }
      if (variantInput) variantInput.value = v.id;
      // Single-option products show each choice's price; refresh it for subscriptions.
      if (picker && product.options.length === 1) {
        $$('input[data-option-index]', picker).forEach(function (el) {
          var sub = el.parentElement.querySelector('[data-opt-sub]'); if (!sub) return;
          var ov = product.variants.find(function (x) { return x.options[0] === el.value; });
          if (ov) sub.textContent = money(priceOf(ov).now);
        });
      }
    }

    function showMedia(id) {
      if (!id) return;
      var t = thumbs.find(function (b) { return b.dataset.mediaId === String(id); });
      if (t && hero) {
        thumbs.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        if (hero.src !== t.dataset.src) { hero.src = t.dataset.src; hero.removeAttribute('srcset'); }
        hero.alt = t.dataset.alt || hero.alt;
        hero.style.objectFit = t.dataset.fit || 'contain';
        hero.style.padding = t.dataset.fit === 'cover' ? '0' : '';
      }
      if (slides) {
        var s = $('[data-media-id="' + id + '"]', slides);
        if (s && slides.offsetParent) slides.scrollTo({ left: s.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      }
    }

    function update() {
      var opts = selectedOptions();
      variant = findVariant(opts);
      markAvailability(opts);
      render();
      if (!variant) return;
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (history.replaceState && opts) {
        var url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
      if (pickupEl) { pickupEl.dataset.variantId = variant.id; loadPickup(); }
    }

    function submit(trigger) {
      if (!form || !variant || !variant.available) return;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      var fd = new FormData(form);
      if (!fd.has('quantity')) fd.set('quantity', String(qty()));
      if (!isSub()) fd.delete('selling_plan');
      var btns = [addBtn, buybarBtn].filter(Boolean);
      btns.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); });
      addToCart(fd)
        .then(function () { flash(trigger || addBtn); if (trigger && trigger !== addBtn) flash(addBtn); })
        .catch(function (err) {
          var msg = err && err.message || H.strings.cartError || 'Something went wrong';
          if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else if (H.toast) H.toast(msg);
        })
        .then(function () { btns.forEach(function (b) { b.removeAttribute('aria-disabled'); }); });
    }

    function loadPickup() {
      if (!pickupEl) return;
      var base = (pickupEl.dataset.baseUrl || '/').replace(/\/$/, '');
      fetch(base + '/variants/' + pickupEl.dataset.variantId + '/?section_id=pickup-availability')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.pickup');
          pickupEl.innerHTML = inner ? inner.outerHTML : '';
        }).catch(function () { pickupEl.innerHTML = ''; });
    }

    // Wiring
    if (picker) picker.addEventListener('change', update);
    if (planWrap) planWrap.addEventListener('change', render);
    if (qtyWrap) {
      qtyWrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-step]'); if (!b || !qtyInput) return;
        qtyInput.value = Math.max(1, Math.min(12, qty() + (b.dataset.step === '-' ? -1 : 1)));
        render();
      });
      if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(addBtn); });
    if (buybarBtn && !buybarBtn.__xrBound) { buybarBtn.__xrBound = true; buybarBtn.addEventListener('click', function () { submit(buybarBtn); }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaId); }); });
    if (slides && dots.length) {
      var st;
      slides.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var kids = $$('.pdp__slide', slides);
          var i = Math.round(slides.scrollLeft / Math.max(1, kids[0] ? kids[0].offsetWidth + 12 : slides.clientWidth));
          dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
        }, 60);
      }, { passive: true });
    }
    var offset = $('[data-recipient-offset]', section);
    if (offset) offset.value = new Date().getTimezoneOffset().toString();

    // Sticky buy bar: on once the real button has scrolled off, off again near the footer.
    if (buybar && addBtn && 'IntersectionObserver' in window && !buybar.__xrIO) {
      buybar.__xrIO = true;
      var foot = $('.foot') || $('.shopify-section-group-footer-group') || $('footer');
      var btnGone = false, footNear = false;
      var sync = function () { buybar.classList.toggle('buybar--on', btnGone && !footNear); buybar.setAttribute('aria-hidden', btnGone && !footNear ? 'false' : 'true'); };
      new IntersectionObserver(function (es) { btnGone = es[0].boundingClientRect.top < 0 && !es[0].isIntersecting; sync(); }).observe(addBtn);
      if (foot) new IntersectionObserver(function (es) { footNear = es[0].isIntersecting; sync(); }).observe(foot);
    }

    variant = findVariant(selectedOptions());
    markAvailability(selectedOptions());
    render();
    if (pickupEl) loadPickup();
  }

  function init(root) { $$('[data-product-section]', root || document).forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
